import type { MappedCarIdentifier } from './mapCarline';

export interface ConcatPrStringOptions {
  readonly model: MappedCarIdentifier['model'];
  readonly color: string;
  readonly interiorColor: string;
  readonly rim: string;
  readonly carlineNameId?: string;
}

export const concatPrString = ({
  model: { code, version, year },
  color,
  interiorColor,
  rim,
}: ConcatPrStringOptions) => `${code}${version}_${year}|${color}|${interiorColor}|${rim}`;

export const concat3DPrString = ({
  model: { code, year },
  color,
  interiorColor,
  rim,
  carlineNameId,
}: ConcatPrStringOptions) => `${carlineNameId},${code},${year},${color},${interiorColor},${rim}`;
